<textarea
  [disabled]="!!answerValidation"
  [ngClass]="{
    error: answerValidation && !answerValidation.valid,
    correct: answerValidation && answerValidation.valid
  }"
  class="regular"
  [formControl]="form"
></textarea>
